export default __webpack_public_path__ + "static/media/04.af2ef09e.png";